import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Please enter the admin password");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/admin-login`, { password });
      localStorage.setItem("adminToken", response.data.token);
      toast.success("Welcome back, Admin!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error("Invalid admin password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src="/nbc_logo.jpg"
            alt="NBC"
            className="h-16 mx-auto mb-6"
          />
          <h1 className="text-3xl font-bold uppercase">Admin Access</h1>
          <p className="text-white/60 mt-2">Enter your admin password to continue</p>
        </div>

        <form onSubmit={handleLogin} className="bg-[#0A0A0A] border border-white/10 p-8 space-y-6">
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
            <Input
              type="password"
              placeholder="Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#050505] border-white/20 h-12 pl-12 text-white placeholder:text-white/40"
              data-testid="admin-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FFB612] text-black hover:bg-[#E5A00D] font-bold uppercase tracking-wide h-12"
            data-testid="admin-login-btn"
          >
            {loading ? "Authenticating..." : "Access Dashboard"}
          </Button>
        </form>

        <p className="text-center text-white/40 text-sm mt-6">
          <a href="/" className="hover:text-[#FFB612]">← Back to Website</a>
        </p>
      </div>
    </div>
  );
};
